const initialState = {
	drawer: false,
	loading: false,
	progress: {
		visible: false,
		percent: 0,
	},
	dialog: {
		visible: false,
		title: '',
		comment: '',
	},
	snack: {
		visible: false,
		severity: 'success',
		duration: null,
		comment: '',
		link: null,
	},
	popover: {
		visible: false,
		anchorEl: null,
		comment: '',
	},
};

export default function reducer(state = initialState, action) {
	if (action.type === 'DRAWER_SET') {
		let newState = Object.assign({}, state);
		newState.drawer = action.payload.drawer;
		return newState;
	}
	else if (action.type === 'LOADING_SET') {
		let newState = Object.assign({}, state);
		newState.loading = action.loading;
		return newState;
	}
	else if (action.type === 'PROGRESS_SET') {
		let newState = Object.assign({}, state);
		newState.progress.visible = action.payload.visible;
		newState.progress.percent = action.payload.percent;
		console.log('progressReducer', action.payload.percent);
		return newState;
	}
	else if (action.type === 'DIALOG_SET') {
		let newState = Object.assign({}, state);
		newState.dialog.visible = action.payload.visible;
		newState.dialog.title = action.payload.title;
		newState.dialog.comment = action.payload.comment;
		return newState;
	}
	else if (action.type === 'SNACK_SET') {
		let newState = Object.assign({}, state);
		newState.snack.visible = action.payload.visible;
		if (action.payload.severity) {
			newState.snack.severity = action.payload.severity;
		}
		if (action.payload.duration > 0) {
			newState.snack.duration = action.payload.duration;
		}
		newState.snack.comment = action.payload.comment;
		if (action.payload.link) {
			newState.snack.link = action.payload.link;
		}
		return newState;
	}
	else if (action.type === 'POPOVER_SET') {
		let newState = Object.assign({}, state);
		newState.popover.visible = action.payload.visible;
		newState.popover.anchorEl = action.payload.anchorEl;
		newState.popover.comment = action.payload.comment;
		return newState;
	}
	else {
		return state;
	}
}
